import {Navigate} from "react-router-dom";

export function RoutesAuthLogout() {
    
    localStorage.clear();

    return <Navigate to={"/auth/login"}/>

}
